import React from "react";
import PropTypes from "prop-types";

import { extractValuesFromObject, resizeBalloonImage } from "@/src/helpers/map/commons";
import { phoneFormatter } from "helpers/phone-formatter";
import Unit from "@/src/utils/constants/units";
import { numberFormatter } from "helpers/number-formatter";

import styles from "./styles.module.css";

const NewListingBalloon = ({ listing }) => {
  const {
    title,
    imagesFullPath,
    estateTypeName,
    roomCountName,
    floorName,
    squareMeter,
    categoryTypeName,
    priceDetail,
    url,
    phoneNumber,
    id,
    quickInfos,
    tradeTypeName,
  } = listing || {};
  const { price, currency } = priceDetail || {};
  const isLandCard = categoryTypeName === "Arsa";
  const isTouristFacility = categoryTypeName === "Turistik Tesis";
  const listingBallonPriceValue =
    tradeTypeName === "Kat Karşılığı" ? "Kat Karşılığı" : `${price?.toLocaleString("tr")} ${currency}`;
  const keysToExtract = ["square", "square_meter_price", "total_area_square"];
  const {
    square: area,
    square_meter_price: pricePerSquareMeter,
    total_area_square: totalArea,
  } = extractValuesFromObject(quickInfos, keysToExtract);

  const listingInformationFields = (
    <div className={styles.informationRow}>
      {estateTypeName && <span>{estateTypeName}</span>}
      {roomCountName && <span>{roomCountName}</span>}
      {floorName && <span>{floorName}</span>}
      {squareMeter && (
        <span>
          {numberFormatter(squareMeter)} {Unit.M2.name}
        </span>
      )}
    </div>
  );

  const landInformationFields = (
    <div className={styles.informationRow}>
      {estateTypeName && <span>{estateTypeName}</span>}
      {area && <span>{area}</span>}
    </div>
  );

  const touristFacilityInformationFields = (
    <div className={styles.informationRow}>
      {estateTypeName && <span>{estateTypeName}</span>}
      {totalArea && <span>{totalArea}</span>}
    </div>
  );

  const formattedPhoneNumber = phoneFormatter(phoneNumber);
  const updatedBalloonImageUrl = resizeBalloonImage(imagesFullPath[0]);
  return (
    <div style={{ position: "relative" }} id={`listingItem-${id}`}>
      <a target="_blank" rel="noreferrer" href={url} className={styles.container}>
        <img src={updatedBalloonImageUrl} className={styles.image} />
        <div className={styles.rightPart}>
          <div className={styles.title}>{title}</div>
          {isLandCard
            ? landInformationFields
            : isTouristFacility
            ? touristFacilityInformationFields
            : listingInformationFields}
          <p className={styles.squareMeterPrice}>{isLandCard ? pricePerSquareMeter : ""}</p>
          <p className={styles.price}>{listingBallonPriceValue}</p>
        </div>
      </a>
      <div
        className={styles.phone_button}
        dangerouslySetInnerHTML={{
          __html: `<button onClick="showPhoneNumber(event, '${formattedPhoneNumber}')">Telefona Bak</button>`,
        }}
      />
    </div>
  );
};

NewListingBalloon.propTypes = {
  listing: PropTypes.object,
};

export default NewListingBalloon;
